// extracted by mini-css-extract-plugin
export default {"description":"IntegrationsModal_description__pArLi","intergations":"IntegrationsModal_intergations__MKhJ6"};